function Nav() {
    return (<>
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="container-fluid">
                <a className="navbar-brand" href="/?page=main">Главная</a>
                <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="true" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="navbar-collapse collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <a className="nav-link" href="/?page=services">Услуги</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/?page=contact">Связь со мной</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/?page=info">Информация</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/?page=taro">Таро</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/?page=manual">Инструкции</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link active" href="/landing/">Мои курсы</a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </>);
}

export default Nav;